export const GOOGLE_AUTH_OPTION = {
  scope: "profile email",
  prompt: "select_account",
  hosted_domain: 'brank.as',
};
